/**
 * see: https://github.com/microsoft/TypeScript/issues/47920 and https://stackoverflow.com/questions/70956050
 * 
 * use: `const dateMap = satisfies<Record<string, Date>>()({ "hello": new Date() });`.
 * 
 * Allows type checking of const without widening of type.  Pass boundary type as generic, call without arguments, then call return type with the object you want to type-check as first argument.
 * @returns Function to pass value into which, in turn, returns exact same object.
 */
export const satisfies = <T,>() => <U extends T>(u: U) => u;